import AppController from './AppController';
import config from 'config';
import helper from '../helper/helpers';
/**
 * To Manage the Trip request
 */
class SolutionDetailsController extends AppController {
	/**
	 * Configure controller
	 */
	constructor() {
		super();
		this.index = this.index.bind(this);
	}
	/**
	* @param {Object} req The request object
	* @param {Object} res The response object
	* @param {function} next The callback to the next program handler
	* @return {void}
	*/
	index(req, res, next) {
		var dataJson = {};
		dataJson.helper = helper;
		dataJson.descLength = config.get('app.descLength');
		dataJson.pageTitle = "Sports Club Management System | CRM for Clubs | Automation for Clubs - JogaApp";
		dataJson.metaDescription = "Manage your clubs and boost your business with JogaApp's powerful Sports Club Management System. The Recreational Club Software has been designed with ease-of-use.";
		dataJson.metaKeyword = "Sports Club Management System, CRM for Clubs, Automation for Clubs, Recreational Club Software, JogaApp, Joga";
		res.render('solution/clubs',dataJson);
		
	}

	solutionTwo(req, res, next) {
		var dataJson = {};
		dataJson.helper = helper;
		dataJson.descLength = config.get('app.descLength');
		dataJson.pageTitle = "Enterprise Management System - JogaApp";
		dataJson.metaDescription = "Enterprise Management System";
		dataJson.metaKeyword = "Enterprise Management System";
		res.render('solution/enterprise',dataJson);
	}

	solutionThree(req, res, next) {
		var dataJson = {};
		dataJson.helper = helper;
		dataJson.descLength = config.get('app.descLength');
		dataJson.pageTitle = "Hotel Activities Management Software | Resorts Management Software - JogaApp";
		dataJson.metaDescription = "Easily organize bookings, payments and get up to date with JogaApp's CRM for Hotels and Resorts. We offer Customer Experience Software that helps you automate your business.";
		dataJson.metaKeyword = "Hotel Management Software, Hotel Activities Management, Resorts Management Software, Customer Experience Software, CRM for Hotels and Resorts";
		res.render('solution/hotels',dataJson);
	}
}

export default SolutionDetailsController;
